import React, { useEffect, useState } from 'react';
import classes from './GeneralInformation.module.css';
import GeneralFinancialInfo from './GeneralFinancialInfo';
import ContactInformation from './ContactInformation';
import Attachments from './Attachments';
import { useAppContext, ContextConstants } from '../../Context/AppContext';
import { hasValue, isValidPhoneNumber, isValidEmail } from '../../Utility';
import { Activity, ActivityString, currentRequestTimeStamp, closeSlidingPopUp } from '../../Constants';
// import ModalUpgrade from '../UpgradeModal/ModalUpgrade';
import mixpanel from 'mixpanel-browser';
import { Urls } from '../../Urls';

const GeneralInformation = () => {
  const {transporterInfo} = useAppContext()
  document.title = 'LoRRI Profile - General Information'
  const { dispatch } = useAppContext();
  // const [show, setshow] = useState(false)
  const [isValidPoc, setIsValidPoc] = useState(false)

  useEffect(() => {
    // setshow(true)
    document.title = 'LoRRI Profile - General Information'
    closeSlidingPopUp()
    dispatch({
      type: ContextConstants.AddGeneralInfoPageValidation,
      payload: isValid
    });
    Activity([{"screen":"General Information","module":"General Information","user_activity":ActivityString.GeneralInformation,"timestamp":currentRequestTimeStamp()}])
    mixpanel.track('User has viewed general information page', {
      ApplicationName: `${Urls.appnamemixpanel}`,
      ScreenName: 'Transporter-Profile',
      ModuleName: 'general-information',
      ActivityLog: 'userViewedGeneralInformationPage',
      Data: 'None',
      Definition: 'User has viewed general information page',
      TransporterName: transporterInfo?.transporter_name,
      TransporterId: transporterInfo?.transporter_id,
      ActivityType: 'page_view'
    });
  }, []);

  const isValid = transporterInfo => {
    return (
      isGeneralInfoValid(transporterInfo) && isPOC(transporterInfo) && isfinancial_infonegative(transporterInfo) && isAreaofOperationsValid(transporterInfo) && isContactInfoValid(transporterInfo)
    );
  };
  
  const isGeneralInfoValid = transporterInfo =>{
    return hasValue(transporterInfo.transporter_name) &&
    hasValue(transporterInfo.headquarter);}
  
  const isContactInfoValid = transporterInfo =>{
   return !transporterInfo.contact_information ||
    !transporterInfo.contact_information.length ||
    !transporterInfo.contact_information.some(c => {
      return (
        !hasValue(c.name) ||
        !hasValue(c.contact_number) ||
        // !isValidPhoneNumber(c.contact_number) ||
        !isValidEmail(c.email)
      );
    });
  }
  
  const isAreaofOperationsValid=(transporterInfo)=>{
    if(transporterInfo.zone.length>0)
  return true
  return false
  }
  const isfinancial_infonegative = (transporterInfo) => {
    if((transporterInfo.net_profit && transporterInfo.net_profit.length > 0 && transporterInfo.net_profit[transporterInfo.net_profit.length - 1].amount && parseInt(transporterInfo.net_profit[transporterInfo.net_profit.length - 1].amount) < 0)
    || (transporterInfo.turnover && transporterInfo.turnover.length > 0 && transporterInfo.turnover[transporterInfo.turnover.length-1].amount && parseInt(transporterInfo.turnover[transporterInfo.turnover.length-1].amount) < 0)){
      return false
    }
    return true
  }
  const isPOC = transporterInfo => {
    var count = 0
    if(transporterInfo.contact_information){
      transporterInfo.contact_information.map((contact, index) => {
        if(contact.poc === "yes"){
          count = count + 1
        }
      })
    }
    if(count < 1){
      setIsValidPoc(true)
      return false
    }
    return true
  }

  return (
    <div className={classes.container}>
      <h3 className={`${classes['s-h3']}`}>General Information</h3>
      {/* <ModalUpgrade show={show} /> */}
      <GeneralFinancialInfo />
      <ContactInformation valid={isValidPoc}/>
      <Attachments />
    </div>
  );
};


export default GeneralInformation;
